import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export function ProviderSwitch() {
  const [d, setD] = useState(null);
  const load = () => api.get("/ai/provider").then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const set = async (provider) => {
    try { const { data } = await api.put("/ai/provider", { provider }); toast.success(`Smart AI now runs on ${data.model}`); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed to switch provider"); }
  };
  if (!d) return null;
  return (
    <div className="flex items-center gap-1 rounded-full bg-white/10 p-1" data-testid="ai-provider-switch" title="Model used by the shopper Smart AI chat, support chat and admin AI commands">
      {d.options.map((o) => (
        <button key={o.id} onClick={() => set(o.id)} data-testid={`ai-provider-${o.id}`} aria-pressed={d.provider === o.id}
          className={`rounded-full px-3 py-1 text-[11px] font-bold transition-colors ${d.provider === o.id ? "bg-amber-400 text-ink" : "text-white/70 hover:text-white"}`}>{o.label}</button>
      ))}
    </div>
  );
}
